import { Alert, Card, Grid, MultiSelect, SegmentedControl, Text, TextInput } from '@mantine/core';
import { TIKTOK_TRACKING_EVENTS, TIKTOK_TRACKING_EVENT_NAMES } from '../../constants/tiktokTrackingEvents';
import OptionsSelect from '../OptionsSelect';
const TikTokSettings = ({ tiktokAccount, handleChange }) => {
  const backendTracking = tiktokAccount?.backendTracking || false;
  // NULL = legacy "send everything", displayed as the full set. Must stay a
  // render-time derivation (never materialized into page state on load) and
  // must be Array.isArray — `|| ALL` would render the deny-all [] as all-8.
  const enabledTrackingEvents = Array.isArray(tiktokAccount?.enabledTrackingEvents)
    ? tiktokAccount.enabledTrackingEvents
    : TIKTOK_TRACKING_EVENT_NAMES;

  return (
    <Card withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Text size="sm" fw={500}>Name</Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <TextInput disabled name="name" type="text" value={tiktokAccount?.name || ''} />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Text size="sm" fw={500}>Email</Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <TextInput disabled name="email" type="text" value={tiktokAccount?.email || ''} />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Text size="sm" fw={500}>Ad account*</Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <OptionsSelect
              name="advertiser"
              endpoint="tiktok/accounts"
              handleChange={handleChange}
              value={tiktokAccount?.advertiserId || ''}
            />
          </Grid.Col>
        </Grid>
        {tiktokAccount?.advertiserId && (
          <>
            <Grid>
              <Grid.Col span={{ base: 12, sm: 4 }}>
                <Text size="sm" fw={500}>Pixel*</Text>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 8 }}>
                <OptionsSelect
                  name="pixel"
                  endpoint={`tiktok/pixels/${tiktokAccount.advertiserId}`}
                  handleChange={handleChange}
                  text="The Tiktok Pixel where all events will be send"
                  value={tiktokAccount?.pixelCode || ''}
                />
              </Grid.Col>
            </Grid>
            <Grid>
              <Grid.Col span={{ base: 12, sm: 4 }}>
                <Text size="sm" fw={500}>
                  Backend Tracking
                </Text>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 8 }}>
                <SegmentedControl
                  value={String(tiktokAccount?.backendTracking || false)}
                  onChange={(value) => handleChange({ target: { name: 'backendTracking', value: value === 'true' } })}
                  data={[
                    { label: 'OFF', value: 'false' },
                    { label: 'ON', value: 'true' },
                  ]}
                />

                <Text size="sm" c="dimmed">
                  Send user behavior as standard events to your selected Pixel Events Manager.
                </Text>
              </Grid.Col>
            </Grid>
            <Grid>
              <Grid.Col span={{ base: 12, sm: 4 }}>
                <Text size="sm" fw={500}>Tracked events</Text>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 8 }}>
                {/* The duplication warning is only actionable while the picker
                    is editable; with Backend Tracking off it would sit above a
                    disabled control an operator cannot act on. */}
                {backendTracking && (
                  <Alert color="yellow" mb="xs" title="Events can be duplicated">
                    Events will be duplicated in your TikTok Pixel if they are sent both from your website and from
                    Releva&apos;s servers, unless both carry the same event ID. Enable only events that your website
                    does not already send.
                  </Alert>
                )}
                <MultiSelect
                  data={TIKTOK_TRACKING_EVENT_NAMES}
                  value={enabledTrackingEvents}
                  onChange={(value) => handleChange({ target: { name: 'enabledTrackingEvents', value } })}
                  placeholder="Pick the TikTok events Releva should send..."
                  disabled={!backendTracking}
                  searchable
                  clearable
                />
                <Text size="sm" c="dimmed">
                  {!backendTracking && <strong>Nothing is sent until Backend Tracking is enabled. </strong>}
                  Releva sends {TIKTOK_TRACKING_EVENTS.map((event) => `${event.value} on ${event.source}`).join(', ')}.
                </Text>
              </Grid.Col>
            </Grid>
          </>
        )}
      </Card.Section>
    </Card>
  );
};

export default TikTokSettings;
